


































































































































import {defineComponent} from '@vue/composition-api';
import DynamicQuestionMixin from '@/tasks/mixins/dynamic-question';
import StembleLatex from '@/tasks/components/StembleLatex.vue';
import ChemicalLatex from '@/tasks/components/displayers/ChemicalLatex.vue';
import CalculationInput from '@/tasks/components/inputs/CalculationInput.vue';

export default defineComponent({
  name: 'Chem116SpriteTitrationReportSheet',
  components: {
    CalculationInput,
    ChemicalLatex,
    StembleLatex,
  },
  mixins: [DynamicQuestionMixin()],
  data() {
    return {
      inputs: {
        volSodaT1: null,
        volInitT1: null,
        volFinalT1: null,
        volNaOHT1: null,

        volSodaT2: null,
        volInitT2: null,
        volFinalT2: null,
        volNaOHT2: null,

        volSodaT3: null,
        volInitT3: null,
        volFinalT3: null,
        volNaOHT3: null,

        volSodaAvg: null,
        volInitAvg: null,
        volFinalAvg: null,
        volNaOHAvg: null,

        molNaOH: null,
        molCitricAcid: null,
        concCitricAcid: null,
      },
    };
  },
});
